import React from "react";
import { PropTypes } from "prop-types";
import reactWrapper from "@harbor/elements/utils/react/wrapper";
import css from "../commonMagneticStyle.less";
import useI18n from "../../i18n/useI18n";

const [HbrTag] = reactWrapper(["hbr-tag"]);

const BetaTag = ({ msg = "", className = "" }) => {
  const { tCommon } = useI18n("common");
  const defaultMsg = msg || tCommon("betaTooltipText");

  return (
    <div
      className={css["beta-tag-content"]}
      data-cy="beta-tag-component"
      title={defaultMsg}
    >
      <HbrTag sentiment="danger" id="negative" className={className}>
        {tCommon("beta")}
      </HbrTag>
    </div>
  );
};

BetaTag.propTypes = {
  msg: PropTypes.string,
  className: PropTypes.string,
};

export default BetaTag;
